import { ProviderListItem } from '../../../integrated-client/models/';

interface ITableData {
  items: Array<ProviderListItem>;
  totalItems?: number;
}

export class TableData implements ITableData {
  items: Array<ProviderListItem>;
  totalItems?: number;

  constructor() {
    this.items = [];
    this.totalItems = 0;
  }

}
